<app-nav-menu></app-nav-menu>
<div class="container pt-5 height-100">
  <div class="">
    <h1 class="dashboard-head">United Travel Insurance</h1>
    <p class="opt-text">Select any service to proceed.</p>
    <div class="section_our_solution">
      <div class="row justify-content-center">
        <div class="">
          <p-tabs value="0">
            <p-tabpanels>
              <p-tabpanel value="0">
                <div class="col-sm-12 table-responsive">
                  <table class="table" style="width:100%">
                    <thead>
                      <tr>
                        <th>Menu</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Issue Policy</td>
                        <td>
                          <div class="so_top_icon" (click)="routeToUnitedIssue()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                              <path fill-rule="evenodd" d="M3,1 C3,0.44772 3.44772,0 4,0 L6,0 C6.55228,0 7,0.44772 7,1 L7,2 C7,2.55228 6.55228,3 6,3 L4,3 C3.44772,3 3,2.55228 3,2 L3,1 Z M2,1 L0,1 L0,14 L10,14 L10,1 L8,1 L8,2.4 L8.6,2.4 L8.6,12.6 L1.4,12.6 L1.4,2.4 L2,2.4 L2,1 Z M4.57808,10.0212 L7.9899,6.6094 L6.99996,5.61945 L4.57808,8.04132 L3.36715,6.83038 L2.3772,7.82033 L4.57808,10.0212 Z" transform="translate(3 1)" />
                            </svg>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Search Booked Policy</td>
                        <td>
                          <div class="so_top_icon" (click)="routeToBooked('11')">
                            <svg fill="currentColor" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="m11.5 21.75c-5.65 0-10.25-4.6-10.25-10.25s4.6-10.25 10.25-10.25 10.25 4.6 10.25 10.25-4.6 10.25-10.25 10.25zm0-19c-4.83 0-8.75 3.93-8.75 8.75s3.92 8.75 8.75 8.75 8.75-3.93 8.75-8.75-3.92-8.75-8.75-8.75z" /><path d="m22.0004 22.7499c-.19 0-.38-.07-.53-.22l-2-2c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z" /></g></svg>
                          </div>
                        </td>
                      </tr>
                      <tr>
                    </tbody>
                  </table>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </div>
      </div>
    </div>
  </div>
</div>
<!--<router-outlet></router-outlet>-->
